export default {
    inserted: function (el) {
        if (window.isViewport(900)) el.focus()
    }
}
